import { useEffect, useRef, useState } from "react";
import OpenDrawer from "../../OpenDrawer/OpenDrawer";
import { Checkbox, InputNumber, Select, Tooltip } from "@arco-design/web-react";
import aImg from "@/assets/cut-mix-detail/a.png";
import bgImg from "@/assets/cut-mix-detail/bg.png";
import boldImg from "@/assets/cut-mix-detail/bold-black.png";
import IImg from "@/assets/cut-mix-detail/i.png";
import rightImg from "@/assets/cut-mix-detail/right.png";
import leftImg from "@/assets/cut-mix-detail/left.png";
import centerImg from "@/assets/cut-mix-detail/center.png";
import fontList from "@/config/fontList";
import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../../../UIComponents/VideoConfigCard/VideoConfigCard";
import FlowerFontCardGroup, {
  IFlowerFontCardGroupForward,
} from "./FlowerFontCardGroup/FlowerFontCardGroup";
import {
  getAssetsFonts,
  getFlowerFont,
} from "@/services/mixCutDetail/mixCutDetail";
import ColorLineImgBlock from "./ColorLineImgBlock/ColorLineImgBlock";
import BgChoiceBlock from "./BgChoiceBlock/BgChoiceBlock";
import { ITextSetting } from "@/stores/mixCutDetailStore/type/caption";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import { getEffectParam } from "@/utils/perm";
import "./LineFontConfig.less";
import BgColorSelect from "./bgColorSelect/index";

const Option = Select.Option;
export interface ILineFontConfig {
  style?: React.CSSProperties;
  data: ITextSetting;
  handleTextSettingChange: (e: ITextSetting) => void;
  global: boolean;
}

const getfontSizeOption = () => {
  return Array.from({ length: 100 }, (_, i) => i + 1);
};

const imgList = [
  {
    value: "left",
    label: rightImg,
  },
  {
    value: "center",
    label: centerImg,
  },
  {
    value: "right",
    label: leftImg,
  },
];

const LineFontConfig: React.FC<ILineFontConfig> = (props) => {
  const { global, style, data, handleTextSettingChange } = props;
  const [fonts, setFonts] = useState<any[]>([]);
  const {
    font,
    font_size,
    color,
    background_color,
    italic,
    alignment,
    effect,
    bold,
    is_global,
    spacing,
    line_spacing,
  } = data || {};

  const [openState, setOpenState] = useState(true);
  const { data: FontList } = useRequest({ request: getFlowerFont });
  const [flowerFontShowAllState] = useState(false);
  const flowerFontGroupRef = useRef<IFlowerFontCardGroupForward>(null);

  const editFontSetting = (e: keyof ITextSetting, value) => {
    console.log("data=============>", data, e, value);

    if (e === "font_size") {
      const { outline, shadow } = getEffectParam(
        value,
        data.effect.advanced as any
      );
      data.outline = outline;
      data.shadow = shadow;
    }
    if (e === "effect") {
      const { outline, shadow } = getEffectParam(
        data.font_size,
        data.effect.advanced as any
      );
      data.outline = outline;
      data.shadow = shadow;
    }
    if (e === "font") {
      const fontObj = fonts.find((item) => item.value === value);
      handleTextSettingChange({
        ...data,
        [e]: fontObj.value,
        font_url: fontObj?.url || "",
      });
    } else {
      handleTextSettingChange({
        ...data,
        [e]: value,
      });
    }
  };

  useEffect(() => {
    getFonts();
  }, []);

  const getFonts = async () => {
    const { data } = await getAssetsFonts();
    const fontObj = JSON.parse(data.value);
    const arr = [...fontObj.official, ...fontObj.custom].map((item) => {
      return {
        value: item.key,
        label: item.name,
        url_type: item?.url_type,
        url: item?.url,
      };
    });
    setFonts(arr);
  };

  return (
    <div style={style}>
      <VideoConfigCard>
        <VideoConfigCardHeader
          headerLeft={
            <>
              <OpenDrawer state={openState} handleStateChange={setOpenState} />
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenState(!openState);
                }}
              >
                设置字体
              </span>
            </>
          }
          headerRight={
            global ? (
              <></>
            ) : (
              <>
                <Checkbox
                  style={{ marginRight: 6 }}
                  checked={is_global}
                  onChange={(e) => {
                    editFontSetting("is_global", e);
                  }}
                >
                  <span style={{ color: "#333333", fontSize: "12px" }}>
                    应用到全部镜头台词
                  </span>
                </Checkbox>
              </>
            )
          }
        ></VideoConfigCardHeader>
        <VideoConfigCardContainer
          style={{ paddingRight: 0, height: `${openState ? "auto" : 0}` }}
        >
          {openState ? (
            <>
              <div className="line-font-config-line">
                <div className="title">选择字体</div>
                <div className="font-setting-config-container">
                  <Select
                    className="border"
                    value={font}
                    placeholder="字体选择"
                    size="small"
                    onChange={(e) => {
                      editFontSetting("font", e);
                    }}
                    style={{ width: 140 }}
                  >
                    {fonts.map((option, index) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    className={"border"}
                    value={font_size}
                    onChange={(e) => {
                      editFontSetting("font_size", e);
                    }}
                    placeholder="12"
                    size="small"
                    style={{ width: 70 }}
                  >
                    {getfontSizeOption().map((option, index) => (
                      <Option
                        key={option}
                        disabled={index === 3}
                        value={option}
                      >
                        {option}
                      </Option>
                    ))}
                  </Select>
                  <div className="font-setting-container">
                    <ColorLineImgBlock
                      tip={"文字颜色"}
                      imgStyle={{ width: 12, height: 12 }}
                      color={color}
                      img={aImg}
                      style={{ marginLeft: 12 }}
                      handleColorChange={(e) => {
                        editFontSetting("color", e);
                      }}
                    />
                    {/*<ColorLineImgBlock*/}
                    {/*  tip={"背景颜色"}*/}
                    {/*  imgStyle={{ width: 12, height: 12 }}*/}
                    {/*  color={background_color}*/}
                    {/*  img={bgImg}*/}
                    {/*  style={{ marginLeft: 12 }}*/}
                    {/*  handleColorChange={(e) => {*/}
                    {/*    editFontSetting("background_color", e);*/}
                    {/*  }}*/}
                    {/*/>*/}
                    <BgChoiceBlock
                      tip="加粗"
                      img={boldImg}
                      isChoice={bold}
                      style={{ marginLeft: 12 }}
                      onClick={() => {
                        editFontSetting("bold", !bold);
                      }}
                    />
                    <BgChoiceBlock
                      tip="斜体"
                      img={IImg}
                      isChoice={italic}
                      onClick={() => {
                        editFontSetting("italic", !italic);
                      }}
                      style={{ marginLeft: 12 }}
                    />
                    <Select
                      className={"border font-select"}
                      id={"wrapper"}
                      getPopupContainer={() => {
                        return document.querySelector("#wrapper");
                      }}
                      size="small"
                      value={alignment}
                      style={{ width: "38px", padding: 0, marginLeft: 12 }}
                      onChange={(e) => {
                        editFontSetting("alignment", e);
                      }}
                      dropdownMenuClassName="option-wrapper"
                    >
                      {imgList.map((item) => {
                        return (
                          <Select.Option value={item.value} key={item.label}>
                            <img
                              src={item.label}
                              alt=""
                              style={{ width: 14, height: 14 }}
                            />
                          </Select.Option>
                        );
                      })}
                    </Select>
                    {/* <img src={rightImg} alt="" /> */}
                  </div>
                </div>
              </div>
              <div
                className="line-font-config-line"
                style={{ marginTop: "20px" }}
              >
                <div className="line-font-config-box">
                  <div className="title" style={{ width: 56 }}>
                    字间距
                  </div>
                  <InputNumber
                    value={spacing}
                    style={{ width: 100, marginLeft: "16px" }}
                    className="font-config-number-input-wrapper"
                    onChange={(e) => {
                      editFontSetting("spacing", e);
                    }}
                    min={0}
                  ></InputNumber>
                </div>
                <div className="line-font-config-box">
                  <div className="title" style={{ width: 56 }}>
                    行间距
                  </div>
                  <InputNumber
                    value={line_spacing}
                    onChange={(e) => {
                      editFontSetting("line_spacing", e);
                    }}
                    style={{ width: 100, marginLeft: "16px" }}
                    className="font-config-number-input-wrapper"
                    min={0}
                  ></InputNumber>
                </div>
              </div>
              <div className="select-bg">
                <div className="title">选择背景</div>
                <BgColorSelect
                  color={background_color}
                  handChange={(e) => {
                    editFontSetting("background_color", e);
                  }}
                />
              </div>
              <div className="flower-font-choose">
                <div className="title">选择花字</div>
                <FlowerFontCardGroup
                  ref={flowerFontGroupRef}
                  maxShowNumber={11}
                  imgList={FontList}
                  activeEfffect={effect}
                  handelFlowerFontIdChange={(e) => {
                    editFontSetting("effect", e);
                  }}
                  style={{ marginLeft: "-16px", flex: 1 }}
                  defaultShowState={flowerFontShowAllState}
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </VideoConfigCardContainer>
      </VideoConfigCard>
    </div>
  );
};

export default LineFontConfig;
